/* Product page + cart drawer fixes v8.

   Does NOT change how items are added. The gift-tee widget (#bndl-blk)
   keeps its own flow, so the cart popup behaves exactly as before.

   Loaded from <head> without defer so the capture listener below
   registers before the widget's own.

   v9: a tap on the bundle's own Colour/Size dropdown counted as a tier
   click (the select sits INSIDE the tier card) and force-reset hoodie #1
   to the page picker. Bundle-internal clicks are now ignored, and the
   forced re-mirror only runs on an actual tier CHANGE.

   v8 changes:
     - PART 2 no longer fires on the widget's own re-render, which made
       the first hoodie's Colour/Size impossible to change.
     - PART 4 (new) caps the $0.00 gift tee at one per cart and removes
       it when there is no hoodie, closing an unlimited-free-product hole.
     - The live price appended to the Add to cart button is hidden. */
(function () {
  if (window.__atcGuardBound) return;
  window.__atcGuardBound = true;

  var GIFT_HANDLE = 'dear-person-t-shirt-bundle-gift';
  var MAIN_HANDLE = 'dear-person-behind-me-you-are-enough-hoodie';
  var MAX_GIFTS = 1; /* free tees allowed per cart */

  var SAFETY_RELEASE_MS = 12000;
  var busy = false;
  var timer = null;
  var activeBtn = null;

  var style = document.createElement('style');
  style.textContent =
    '.atc-guard-busy{position:relative;opacity:.75;cursor:progress;}' +
    '.atc-guard-busy > *{visibility:hidden;}' +
    '.atc-guard-busy::after{content:"Adding\\2026";position:absolute;top:0;right:0;' +
    'bottom:0;left:0;display:flex;align-items:center;justify-content:center;' +
    'visibility:visible;font:inherit;letter-spacing:.02em;}' +
    /* the widget appends the live bundle price to the theme's ATC button */
    '.bndl-btn-price{display:none !important;}';
  (document.head || document.documentElement).appendChild(style);

  /* ==========================================================
     PART 1 - Add-to-cart guard
     1. Dead first tap: the widget stopImmediatePropagation()s the click,
        killing the theme's loading state, then runs several sequential
        requests before the popup shows. We paint "Adding..." instantly.
     2. Double-add: the widget frees its busy flag ~1.4s before its final
        add lands, so a second tap doubled the cart. We hold our own lock
        until the popup opens (or 12s) and swallow extra taps.
     Only trusted taps are gated - script-dispatched clicks are
     isTrusted:false and pass through, which is how the widget re-fires
     the theme's native add internally.
     ========================================================== */
  function addButtonFrom(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest(
      'button[name="add"], [name="add"], button[type="submit"], input[type="submit"]'
    );
    if (!btn) return null;
    if (btn.closest('#bndl-blk')) return btn;
    var form = btn.closest('form');
    if (!form) return null;
    if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return null;
    return btn;
  }

  function lock(btn) {
    busy = true;
    activeBtn = btn || null;
    if (activeBtn) {
      activeBtn.classList.add('atc-guard-busy');
      activeBtn.setAttribute('aria-busy', 'true');
    }
    clearTimeout(timer);
    timer = setTimeout(release, SAFETY_RELEASE_MS);
  }

  function release() {
    busy = false;
    clearTimeout(timer);
    if (activeBtn) {
      activeBtn.classList.remove('atc-guard-busy');
      activeBtn.removeAttribute('aria-busy');
      activeBtn = null;
    }
    scheduleGiftCap();
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var btn = addButtonFrom(e.target);
    if (!btn) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    lock(btn);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!e.isTrusted || busy) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    lock(form.querySelector('button[name="add"], [name="add"], button[type="submit"]'));
  }, true);

  /* ==========================================================
     PART 2 - Bundle variant sync  (FIXED in v8)
     The widget builds the cart from ITS OWN selects, so the picker's
     variant is mirrored into the bundle's FIRST hoodie (unit 0).

     v7 re-ran this from a MutationObserver on the tier container. The
     widget re-renders itself on EVERY select change, so the observer
     fired straight after the shopper's choice and wrote the picker's
     value back - unit 0 could never be changed from inside the bundle.

     v8 syncs only when the picker's variant id has actually changed
     since the last sync, plus a forced sync on tier switch (where the
     widget resets its units to defaults anyway, so nothing is lost).
     ========================================================== */
  var lastPickerVariantId = null;

  function syncBundleToPicker(force) {
    var root = document.getElementById('bndl-blk');
    var dataEl = document.querySelector('[data-bndl-data]');
    if (!root || !dataEl) return;

    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    /* the shopper has not touched the picker since we last mirrored it,
       so any difference below is the shopper's own bundle choice */
    if (!force && String(idInput.value) === String(lastPickerVariantId)) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.main || !data.main.variants) return;

    var current = null;
    for (var i = 0; i < data.main.variants.length; i++) {
      if (String(data.main.variants[i].id) === String(idInput.value)) {
        current = data.main.variants[i];
        break;
      }
    }
    if (!current) return;

    var card = root.querySelector('.bndl-card.is-active');
    if (!card) return;
    var t = card.getAttribute('data-tier');

    lastPickerVariantId = String(idInput.value);

    for (var o = 0; o < current.opts.length; o++) {
      var sel = root.querySelector(
        'select[data-t="' + t + '"][data-u="0"][data-g="0"][data-o="' + o + '"]'
      );
      if (!sel || sel.value === current.opts[o]) continue;
      var exists = false;
      for (var k = 0; k < sel.options.length; k++) {
        if (sel.options[k].value === current.opts[o]) { exists = true; break; }
      }
      if (!exists) continue;
      sel.value = current.opts[o];
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncBurst(delays, force) {
    (delays || [0, 120, 350, 700, 1200, 1800]).forEach(function (d) {
      setTimeout(function () { syncBundleToPicker(force); }, d);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) syncBurst();
  });
  var lastActiveTier = null;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('variant-selects, variant-radios')) { syncBurst(); return; }
    /* The shopper is editing the bundle's own Colour/Size. Those selects sit
       INSIDE the tier card, so without this guard a tap on the dropdown was
       read as a tier click and force-reset unit 0 back to the page picker -
       making the first hoodie impossible to change. Mirrors the widget's own
       "ignore select / .bndl-pill" rule. */
    if (e.target.closest('#bndl-blk select, #bndl-blk .bndl-pill')) return;
    var card = e.target.closest('#bndl-blk [data-tier]');
    if (!card) return;
    /* Only a genuine tier CHANGE rebuilds the units from defaults, so only
       then is re-mirroring the picker free of side effects. Re-tapping the
       card already open must not discard the shopper's choice. */
    var t = card.getAttribute('data-tier');
    if (t === lastActiveTier) return;
    lastActiveTier = t;
    syncBurst([60, 200, 500], true);
  });

  /* ==========================================================
     PART 3 - Cart drawer content
     The drawer's innerHTML is replaced on every cart change, so these
     blocks are re-applied by a MutationObserver. Each insert is guarded
     by an existence check and the button label is only rewritten when it
     differs, so the observer converges instead of looping.
     Styling lives in assets/cart-drawer-custom.css.
     ========================================================== */
  var WARNING_HTML =
    '<div class="cd-warning" role="status">' +
      '<span class="cd-warning__icon" aria-hidden="true">⚠️</span>' +
      '<span class="cd-warning__text"><strong>WARNING:</strong> Our product has sold out 4x this ' +
      'year. Order now before it’s too late!</span>' +
    '</div>';

  var GUARANTEE_HTML =
    '<div class="cd-guarantee">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M12 2l7 3v6c0 4.4-3 8.4-7 11-4-2.6-7-6.6-7-11V5l7-3z" fill="#0e4699"></path>' +
        '<path d="M9.4 12.2l1.9 1.9 3.4-3.7" stroke="#ffffff" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>' +
      '<span>30 Day Money-Back Guarantee</span>' +
    '</div>';

  function decorateDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var header = drawer.querySelector('.drawer__header');
    if (header && !drawer.querySelector('.cd-warning')) {
      header.insertAdjacentHTML('afterend', WARNING_HTML);
    }

    var btn = drawer.querySelector('#CartDrawer-Checkout');
    if (btn && btn.textContent.trim() !== 'Proceed To Checkout') {
      btn.textContent = 'Proceed To Checkout';
    }

    var ctas = drawer.querySelector('.cart__ctas');
    if (ctas && !drawer.querySelector('.cd-guarantee')) {
      ctas.insertAdjacentHTML('afterend', GUARANTEE_HTML);
    }
  }

  /* ==========================================================
     PART 4 - Free gift cap  (new in v8)
     The gift tee is a real $0.00 product, so nothing server-side limits
     it. Adding the bundle N times produced N free tees, and the product
     URL let anyone order any quantity for $0.00.

     Rule enforced here: at most MAX_GIFTS gift tees per cart, and none
     at all when the cart holds no hoodie.

     Never runs while an add is in flight (busy), because the widget
     pre-adds the gift BEFORE the hoodie - acting then would delete the
     legitimate gift. Converges: once the cart complies, no write is made.
     ========================================================== */
  var capBusy = false;
  var capTimer = null;

  function sectionsToRender(drawer) {
    try {
      return drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    } catch (e) {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
  }

  function enforceGiftCap() {
    if (capBusy || busy) return;
    capBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLines = [];
        var giftQty = 0;
        var mainQty = 0;
        (cart.items || []).forEach(function (item) {
          if (item.handle === GIFT_HANDLE) {
            giftLines.push(item);
            giftQty += item.quantity;
          } else if (item.handle === MAIN_HANDLE) {
            mainQty += item.quantity;
          }
        });

        var allowed = mainQty > 0 ? MAX_GIFTS : 0;
        if (giftQty <= allowed) return null;

        var updates = {};
        var remaining = allowed;
        giftLines.forEach(function (item) {
          var keep = Math.min(item.quantity, remaining);
          remaining -= keep;
          if (keep !== item.quantity) updates[item.key] = keep;
        });
        if (!Object.keys(updates).length) return null;

        var drawer = document.querySelector('cart-drawer');
        var payload = { updates: updates };
        if (drawer) {
          payload.sections = sectionsToRender(drawer);
          payload.sections_url = window.location.pathname;
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        capBusy = false;
        if (!state) return;
        if (/^\/cart/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        }
      })
      .catch(function () { capBusy = false; });
  }

  function scheduleGiftCap() {
    clearTimeout(capTimer);
    capTimer = setTimeout(enforceGiftCap, 700);
  }

  function watchDrawerContent() {
    var host = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!host) return false;
    new MutationObserver(function () {
      decorateDrawer();
      scheduleGiftCap();
    }).observe(host, { childList: true, subtree: true });
    decorateDrawer();
    return true;
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) release();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  function init() {
    var doneDrawer = watchDrawer();
    var doneContent = watchDrawerContent();
    var activeCard = document.querySelector('#bndl-blk .bndl-card.is-active');
    lastActiveTier = activeCard ? activeCard.getAttribute('data-tier') : null;
    syncBurst();
    scheduleGiftCap();
    if (doneDrawer && doneContent) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (!doneDrawer) doneDrawer = watchDrawer();
      if (!doneContent) doneContent = watchDrawerContent();
      if ((doneDrawer && doneContent) || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
